import { render, staticRenderFns } from "./ClassifierSelect.vue?vue&type=template&id=918b23e6&"
import script from "./ClassifierSelect.vue?vue&type=script&lang=js&"
export * from "./ClassifierSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports